import React, { useEffect, useState } from "react";
import LikeTrackBtn from "../LikeTrackBtn";
import DislikeTrackBtn from "../DislikeTrackBtn";
import { useDispatch, useSelector } from "react-redux";
import useClickWithAuth from "../../hooks/useClickWithAuth";
import { setCurrentContent } from "../../redux/Slice/playerSlice";
import { selectCurrentContent } from "../../redux/selectors/playerSelector";
import { useLikePodcastTrackMutation } from "../../api/podcastsApi";
import toast from "react-hot-toast";
import { useRateTrackMutation } from "../../api/tracksApi";

// isRelease будет отвечать за проверку, подкаст это или нет

const FooterPlayerRatingActions = ({ rating, trackId, isRelease, isLike }) => {
  const dispatch = useDispatch();
  const [like, setLike] = useState(rating);
  const currentContent = useSelector(selectCurrentContent);
  const [rateTrack] = useRateTrackMutation();

  const handleClickWithAuth = useClickWithAuth();

  // Всё что касается лайков и дизлайков подкастов
  const [likePodcastTrack] = useLikePodcastTrackMutation();
  const isPodcastLiked = currentContent.isLiked;

  useEffect(() => {
    setLike(rating);
  }, [rating]);

  const handlePodcastRating = async (e, shouldLike) => {
    e.preventDefault();
    const currentRating = isPodcastLiked;
    let newRating;

    if (shouldLike) {
      newRating = currentRating === true ? null : true;
    } else {
      newRating = currentRating === false ? null : false;
    }

    try {
      await likePodcastTrack({
        is_liked: newRating,
        podcast_track_id: currentContent.id,
      }).unwrap();

      dispatch(setCurrentContent({ ...currentContent, isLiked: newRating }));

      if (shouldLike) {
        if (currentRating === true) {
          toast.success("Вы убрали лайк");
        } else {
          toast.success("Вы лайкнули выпуск");
        }
      } else {
        if (currentRating === false) {
          toast.success("Вы убрали дизлайк");
        } else {
          toast.success("Вы дизлайкнули выпуск");
        }
      }
    } catch {}
  };

  const handleTrackRating = async (e, shouldLike) => {
    e.preventDefault();
    const currentRating = like;
    let newRating;

    if (shouldLike) {
      newRating = currentRating === true ? null : true;
    } else {
      newRating = currentRating === false ? null : false;
    }

    setLike(newRating);

    try {
      dispatch(
        setCurrentContent({ ...currentContent, user_rating: newRating }),
      );
      await rateTrack({ rating: newRating, trackId });

      if (shouldLike) {
        if (currentRating === true) {
          toast.success("Вы убрали лайк");
        } else {
          toast.success("Вы лайкнули песню");
        }
      } else {
        if (currentRating === false) {
          toast.success("Вы убрали дизлайк");
        } else {
          toast.success("Вы дизлайкнули песню");
        }
      }
    } catch (error) {
      dispatch(setCurrentContent({ ...currentContent, user_rating: rating }));
      setLike(rating);
    }
  };

  const getClickHandler = (isLikeAction) => {
    if (isRelease) {
      return (e) => handlePodcastRating(e, isLikeAction);
    } else {
      return (e) => handleTrackRating(e, isLikeAction);
    }
  };

  const currentRatingStatus = isRelease ? isPodcastLiked : like;

  return (
    <>
      {isLike ? (
        <LikeTrackBtn
          onClick={handleClickWithAuth(getClickHandler(isLike))}
          like={currentRatingStatus}
        />
      ) : (
        <DislikeTrackBtn
          onClick={handleClickWithAuth(getClickHandler(isLike))}
          like={currentRatingStatus}
        />
      )}
    </>
  );
};

export default FooterPlayerRatingActions;
